import { Box } from "@mui/material";
import NoDataBanner from "components/common/NoDataBanner";
import {
  fetchMeticsPlansIdsAsync,
  fetchSuggestedPlansAsync,
  resetMetricsPlansIds,
  setSuggestedPlanList
} from "components/features/dashboard/HotelUserDashboard.slice";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import List from "./List";

interface props {
  metricsName?: string;
}
export default function MetricsPlans(props: props) {
  const dispatch = useAppDispatch();
  const { metricsName } = props;
  const innCode = useAppSelector((state: any) => state.app.innCode);
  const planIds = useAppSelector((state) => state.hotelUserDashboardSlice.suggestedPlans.metricsPlansIds);
  const plansList = useAppSelector((state) => state.hotelUserDashboardSlice.suggestedPlans.SuggestedPlansList);

  const [searchParams, setSearchParams] = useSearchParams();

  const externalHltId = searchParams.get("member");

  useEffect(() => {
    return () => {
      dispatch(resetMetricsPlansIds());
      dispatch(setSuggestedPlanList());
    };
  }, []);

  useEffect(() => {
    const payload = {
      metrics: [metricsName],
      excludeFocusAreas: true
    };
    if (innCode) dispatch(fetchMeticsPlansIdsAsync({ innCode: innCode, payload: payload }));
  }, [innCode]);

  useEffect(() => {
    if (planIds?.length > 0) {
      const getSuggestedPlans = async () => {
        const cmsIds = planIds?.map((i: any) => i?.cmsId);
        const props: any = {
          externalHltId,
          filter: {
            innCode,
            ids: cmsIds
          },
          pagination: {
            page: 1,
            size: 5
          },
          isSortingDisabled: true,
          myPlansDisabled: true
        };
        await dispatch(fetchSuggestedPlansAsync(props));
      };
      getSuggestedPlans();
    }
  }, [planIds]);

  return (
    <>
      {plansList?.length > 0 ? (
        <List plansList={plansList} />
      ) : (
        <Box className="no-plans-banner">
          <NoDataBanner />
        </Box>
      )}
    </>
  );
}
